import { AppContext } from '../../AppContext';
import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { isAuthenticated } from '../../services/authService';

export const PrivateRoute = ({ component, ...rest }: any) => {
  const {userManager} = useContext(AppContext);
  const isUserAuthenticated = isAuthenticated(userManager);
  const history = useHistory();

  const renderFn = (Component: any) => (props: any) => {
    if (!!Component && !!isUserAuthenticated) {
      return <Component {...props} />;
    } else {
      history.push('/loginWithExtranet');
    }
  };

  return <Route {...rest} render={renderFn(component)} />;
};
